import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/form/Input';
import './selecaoPerfil.css';

const SelecionaTipoPessoa = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [perfil, setPerfil] = React.useState('pf');
  const handleOptionChange = (event) => {
    setPerfil(event.target.value);
  };
  const chamaCadastro = () => {
    if (perfil == 'pf') {
      navigate('/cadastroPF');
    } else if (perfil == 'pj') {
      navigate('/cadastroPJ');
    }
  };
  return (
    <div id="seleciona-perfil" className="conteudo">
      <div id="bem-vindo" className="conteudo card bg-superficie elev5">
        <img
          alt={t('cadastro.accessibility.carol_image')}
          id="img-carol-boasvindas"
          src="/images/carol-perfil.png"
        />

        <h2>{t('cadastro.titles.select_profile')}</h2>
        <div className="controle">
          <label className="radio">
            <Input
              type="radio"
              id="pf"
              name="perfil"
              value="pf"
              checked={perfil === 'pf'}
              onChange={handleOptionChange}
            />
            <div className="subtitulo">
              <span>{t('cadastro.forms.options.individual')}</span>
              <span className="legenda">
                {t('cadastro.messages.info.individual_description', {
                  defaultValue:
                    'Se você for brasileiro ou estrangeiro e quer se cadastrar',
                })}
              </span>
            </div>
          </label>

          <label className="radio">
            <Input
              type="radio"
              id="pj"
              value="pj"
              name="perfil"
              checked={perfil === 'pj'}
              onChange={handleOptionChange}
            />
            <div className="subtitulo">
              <span>{t('cadastro.forms.options.business')}</span>
              <span className="legenda">
                {t('cadastro.messages.info.business_description', {
                  defaultValue: 'Se você for cadastrar uma empresa',
                })}
              </span>
            </div>
          </label>
        </div>
        <div className="btns-row">
          <button
            id="btn-voltar"
            type="button"
            className="btn-txt"
            onClick={() => navigate('/login')}
          >
            {t('cadastro.forms.buttons.back')}
          </button>

          <button
            id="btn-prosseguir"
            type="button"
            className="btn-pre"
            onClick={() => chamaCadastro()}
          >
            {t('cadastro.forms.buttons.continue')}
          </button>
        </div>
      </div>
    </div>
  );
};
export default SelecionaTipoPessoa;
